import * as THREE from 'three';
import { PlanogramObject } from "./PlanogramObject.js";
import { PlanogramBlocking } from "./PlanogramBlocking.js"
import { PlanogramRenderer } from "./PlanogramRenderer.js";

export class PlanogramBlockingPosition extends HTMLElement {
    static attributes = {
        X: 'x',
        Y: 'y',
        Width: 'width',
        Height: 'height',
        Colour: 'colour',
        FillStyle: 'fill-style',
        Selected: 'selected'
    }
    static get observedAttributes(){
        return [ ...Object.values(PlanogramBlockingPosition.attributes) ];
    }

    /**@type {PlanogramBlocking} */
    #parentBlocking = null;
    firstRender = true;

    get x() { return Number(this.getAttribute(PlanogramBlockingPosition.attributes.X)) || 0; }
    get y() { return Number(this.getAttribute(PlanogramBlockingPosition.attributes.Y)) || 0; }
    get width() { return Number(this.getAttribute(PlanogramBlockingPosition.attributes.Width)) || 1; }
    get height() { return Number(this.getAttribute(PlanogramBlockingPosition.attributes.Height)) || 1; }
    get colour() { return PlanogramObject.computeColour(this.getAttribute(PlanogramBlockingPosition.attributes.Colour), 0xffffff, true); }
    get fillStyle() { return Number(this.getAttribute(PlanogramBlockingPosition.attributes.FillStyle)) || 0; }
    get selected() { return this.hasAttribute(PlanogramBlockingPosition.attributes.Selected); }

    constructor(){
        super();
    }

    /**
     * 
     * @param {THREE.Vector3} planSize 
     * @returns {THREE.Vector3}
     */
    getDimensions(planSize){
        return new THREE.Vector3(this.width * planSize.x, this.height * planSize.y, planSize.z);
    }

    /**
     * 
     * @param {THREE.Vector3} planSize 
     * @returns {THREE.Vector3}
     */
    getPosition(planSize){
        return new THREE.Vector3((this.x + this.width/2) * planSize.x, (this.y + this.height/2) * planSize.y, planSize.z/2);
    }

    /**
     * 
     * @param {boolean} isDefault 
     * @returns {THREE.Vector4}
     */
    getOptions( isDefault = false ){
        return new THREE.Vector4(this.colour, this.selected ? 1 : 0, this.fillStyle, isDefault ? 0 : 1);
    }

    /**
     * 
     * @returns {PlanogramBlockingPosition}
     */
    static createDefault(){
        return document.createElement("planogram-blocking-location");
    }

    raiseClickEvent( x, y, rightClick = false){
        const renderer = PlanogramRenderer.get(this);
        const rect = renderer.domElement.getBoundingClientRect();
        const clickEvent = new MouseEvent( "click", { bubbles: true, cancelable: true, view: window, clientX: rect.x + x, clientY: rect.y + y });
        Object.defineProperty(clickEvent, 'button', { ...Object.getOwnPropertyDescriptor(clickEvent, 'button'), get: function() {return rightClick ? 2 : 0;}});
        Object.defineProperty(clickEvent, 'target', { ...Object.getOwnPropertyDescriptor(clickEvent, 'target'), get: (function() {return this;}).bind(this)});
        if( this.dispatchEvent(clickEvent) && renderer.showMessages ){
            console.groupCollapsed("PlanogramBlockingPosition Selected"+ (rightClick? " and Context Menu":""));
            console.log("Target: ", this);
            console.log("Event: ", clickEvent);
            console.groupEnd();
        }
    }

    connectedCallback() {
        if(this.parentElement instanceof PlanogramBlocking ){
            this.#parentBlocking = this.parentElement;
            this.firstRender = false;
            this.#parentBlocking.updateMeshes();
        }
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (this.firstRender || oldValue === newValue ) return;
        this.#parentBlocking?.updateMeshes();
    }

    disconnectedCallback() {
        this.#parentBlocking?.updateMeshes();
    }

}